import { AxiosError } from 'axios';
import { GET_APPLICATION_FILE_INFORMATION_URL } from '../../constants/apiUrls';
import { useCustomQuery } from '../utils/useCustomQuery';
import { FileUploadState } from '../../models/File';
import axiosClient from '../axiosClient';
import { GET_APPLICATION_FILE_INFORMATION_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GetDocumentUploadStatusResponse {
  fileStatus: FileUploadState;
  url?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: GetDocumentUploadStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  fileKey: string;
  refetchInterval: number | undefined;
}

export const useGetApplicationFileStatus = ({
  fileKey,
  enabled = false,
  onSuccess,
  onError,
  refetchInterval,
}: Input) => {
  const getApplicationFileStatus = async () => {
    const res = await axiosClient.get<GetDocumentUploadStatusResponse>(
      GET_APPLICATION_FILE_INFORMATION_URL(fileKey)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_APPLICATION_FILE_INFORMATION_QUERY_KEY, fileKey],
    getApplicationFileStatus,
    {
      onSuccess,
      onError,
      retryOnMount: true,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      refetchInterval,
      enabled,
    },
    false
  );
};
